<template>
  <v-app>
    <v-container fluid class="pa-0">
      <v-form @submit.prevent="submit">
        <v-row class="mt-3">
          <v-col cols="12" md="3">
              <v-expansion-panels v-model="panel" multiple>
                <v-expansion-panel>
                  <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">
                    {{ isEntryMode ? 'Buyer Order Information' : 'Buyer Order Information' }}
                  </v-expansion-panel-title>

                  <v-expansion-panel-text>
                    <v-card flat>
                      <v-card-text>

                          <v-row dense>

                            <v-col cols="12">
                                <v-autocomplete
                                    v-model="buyer_id.value.value"
                                    :items="getCustomerMapList"
                                    :item-title="item => `${item.customer?.company_name ?? ''} - ${item.customer?.code ?? ''}`"
                                    :item-value="item => item.customer?.id ?? null"
                                    variant="outlined"
                                    density="compact"
                                    :error-messages="buyer_id.errorMessage.value"
                                    clearable
                                >
                                <template #label>
                                    Buyer <span class="text-red">*</span>
                                </template>
                                </v-autocomplete>
                            </v-col>

                             <v-col cols="12">
                                <v-date-input
                                    v-model="order_date.value.value"
                                    label="Order Date *"
                                    variant="outlined"
                                    density="compact"
                                    prepend-inner-icon="mdi-calendar"
                                    prepend-icon=""
                                    :error-messages="order_date.errorMessage.value"
                                    clearable
                                />
                            </v-col>


                            <v-col cols="12">
                                <v-date-input
                                    v-model="order_receive_date.value.value"
                                    label="Order Received Date *"
                                    variant="outlined"
                                    density="compact"
                                    prepend-inner-icon="mdi-calendar"
                                    prepend-icon=""
                                    :error-messages="order_receive_date.errorMessage.value"
                                    clearable
                                />
                            </v-col>

                            <v-col cols="12">
                                <v-date-input
                                    v-model="delivery_date.value.value"
                                    label="Delivery Date *"
                                    variant="outlined"
                                    density="compact"
                                    prepend-inner-icon="mdi-calendar"
                                    prepend-icon=""
                                    :error-messages="delivery_date.errorMessage.value"
                                    clearable
                                />
                            </v-col>


                            <v-col cols="12">
                                <v-autocomplete
                                v-model="order_type.value.value"
                                :items="getOrderType"
                                :item-title="item => `${item.label}`"
                                :item-value="item => item.value"
                                label="SMV"
                                variant="outlined"
                                density="compact"
                                :error-messages="order_type.errorMessage.value"
                                clearable
                                >
                                <template #label>
                                    Order Type <span class="text-red">*</span>
                                </template>
                                </v-autocomplete>
                            </v-col>

                            <v-col cols="12">
                              <v-text-field
                                v-model="smv.value.value"
                                label="SMV"
                                variant="outlined"
                                density="compact"
                                min="0"
                                clearable
                                :error-messages="smv.errorMessage.value"
                              />
                            </v-col>

                            <v-col cols="12">
                              <v-text-field
                                v-model="efficiency.value.value"
                                label="Efficiency"
                                variant="outlined"
                                density="compact"
                                min="0"
                                clearable
                                :error-messages="efficiency.errorMessage.value"
                              />
                            </v-col>


                            <v-col cols="12">
                              <v-text-field
                                v-model="brand.value.value"
                                label="Brand"
                                variant="outlined"
                                density="compact"
                                clearable
                                :error-messages="brand.errorMessage.value"
                              />
                            </v-col>

                            <v-col cols="12">
                                <v-autocomplete
                                v-model="season.value.value"
                                :items="getSeason"
                                :item-title="item => `${item.label}`"
                                :item-value="item => item.value"
                                label="SMV"
                                variant="outlined"
                                density="compact"
                                :error-messages="season.errorMessage.value"
                                clearable
                                >
                                <template #label>
                                    Season <span class="text-red">*</span>
                                </template>
                                </v-autocomplete>
                            </v-col>


                            <v-col cols="12">
                                <v-date-input
                                    v-model="shipment_date.value.value"
                                    label="Shipment Date *"
                                    variant="outlined"
                                    density="compact"
                                    prepend-inner-icon="mdi-calendar"
                                    prepend-icon=""
                                    :error-messages="shipment_date.errorMessage.value"
                                    clearable
                                />
                            </v-col>

                            <v-col cols="12">
                                <v-autocomplete
                                v-model="shipment_mode.value.value"
                                :items="getShipmentMode"
                                :item-title="item => `${item.label}`"
                                :item-value="item => item.value"
                                label="Shipment Mode"
                                variant="outlined"
                                density="compact"
                                :error-messages="shipment_mode.errorMessage.value"
                                clearable
                                >
                                </v-autocomplete>
                            </v-col>

                            <v-col cols="12">
                                <v-autocomplete
                                    v-model="delivery_terms.value.value"
                                    :items="getDeliveryTerm"
                                    :item-title="item => `${item.label}`"
                                    :item-value="item => item.value"
                                    label="Delivery Term"
                                    variant="outlined"
                                    density="compact"
                                    :error-messages="delivery_terms.errorMessage.value"
                                    clearable
                                    >
                                </v-autocomplete>
                            </v-col>


                            <v-col cols="12">
                                <v-autocomplete
                                    v-model="currency_id.value.value"
                                    :items="getCurrencyList"
                                    :item-title="item => `${item.code} - ${item.name}`"
                                    item-value="id"
                                    variant="outlined"
                                    density="compact"
                                    :error-messages="currency_id.errorMessage.value"
                                    clearable
                                >
                                <template #label>
                                    Currency <span class="text-red">*</span>
                                </template>
                                </v-autocomplete>
                            </v-col>

                            <v-col cols="12">
                              <v-text-field
                                v-model="payment_terms.value.value"
                                label="Payment Terms"
                                variant="outlined"
                                density="compact"
                                clearable
                                :error-messages="payment_terms.errorMessage.value"
                              />
                            </v-col>

                            <v-col cols="12">
                                <v-autocomplete
                                    v-model="order_priority.value.value"
                                    :items="getOrderPriority"
                                    :item-title="item => `${item.label}`"
                                    :item-value="item => item.value"
                                    variant="outlined"
                                    density="compact"
                                    :error-messages="order_priority.errorMessage.value"
                                    clearable
                                >
                                <template #label>
                                    Order Priority <span class="text-red">*</span>
                                </template>
                                </v-autocomplete>
                            </v-col>


                            <v-col cols="12">
                              <v-text-field
                                v-model="sales_person.value.value"
                                label="Sales Person"
                                variant="outlined"
                                density="compact"
                                clearable
                                :error-messages="sales_person.errorMessage.value"
                              />
                            </v-col>

                          </v-row>
    
                      </v-card-text>
                    </v-card>
                  </v-expansion-panel-text>
                </v-expansion-panel>
              </v-expansion-panels>
          </v-col>
          <v-col col="12" md="9">
              <v-row>
                <v-col cols="12">
                  <v-expansion-panels v-model="panel2" multiple>
                    <v-expansion-panel>
                      <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">
                        Styles Section
                      </v-expansion-panel-title>

                      <v-expansion-panel-text>
                        <v-card flat>
                          <v-card-text>

                              <v-row>
                                <v-col cols="12" class="pa-0">

                                  <v-expansion-panels multiple>

                                    <v-expansion-panel
                                      v-for="(item, i) in items"
                                      :key="i"
                                    >

                                      <!-- ================= ROW HEADER ================= -->
                                      <v-expansion-panel-title style="padding:10px 3px; background-color:#cfd8dc;">
                                        <table style="width:100%; font-size:13px; border-collapse:collapse;">
                                          <tbody>
                                            <tr>
                                              <!-- <td style="width:5%">{{ i + 1 }}</td> -->

                                              <td style="padding: 0px 5px;">
                                                <v-autocomplete
                                                
                                                  variant="outlined"
                                                  density="compact"
                                                  label="Style*"
                                                  bg-color="grey-lighten-4"
                                                  v-model="item.style_id"
                                                  :items="getProductionStyleList"
                                                  :item-title="(item) =>`${item?.name ?? 'Select'} ${item?.code ?? ''}`"
                                                  item-value="id"
                                                  autocomplete="off"
                                                  hide-details
                                                  clearable
                                                  @update:model-value="onItemStyleChange(i)"
                                                  @click.stop
                                                  @mousedown.stop
                                                ></v-autocomplete>
                                              </td>

                                              <td style="width:18%;  padding: 0px 5px;">
                                                <v-text-field
                                                  @click.stop
                                                  @mousedown.stop
                                                  v-model="item.order_quantity"
                                                  type="number"
                                                  min="0"
                                                  step="0.01"
                                                  variant="outlined"
                                                  density="compact"
                                                  label="Order Quantity*"
                                                  class="text-right"
                                                  hide-details
                                                  readonly=""
                                                  disabled=""
                                                ></v-text-field>
                                              </td>

                                              <!-- <td style="width:18%;  padding: 0px 5px;">
                                                <v-text-field
                                                  @click.stop
                                                  @mousedown.stop
                                                  v-model="item.unit_price"
                                                  type="number"
                                                  min="0"
                                                  step="0.01"
                                                  variant="outlined"
                                                  density="compact"
                                                  label="Unit price*"
                                                  class="text-right"
                                                  @input="onItemUnitPriceChange(i)"
                                                  hide-details
                                                ></v-text-field>
                                              </td> -->

                                              <td style="width:18%; padding: 0px 5px;">
                                                <v-text-field
                                                  @click.stop
                                                  @mousedown.stop
                                                  v-model="item.total_value"
                                                  type="number"
                                                  min="0"
                                                  step="0.01"
                                                  variant="outlined"
                                                  density="compact"
                                                  label="Total value*"
                                                  class="text-right"
                                                  hide-details
                                                  readonly
                                                  disabled=""
                                                ></v-text-field>
                                              </td>

                                              <td style="width: 90px; text-align:right">
                                                  <v-btn @click.stop @mousedown.stop v-if="i == items.length - 1" variant="tonal" icon size="small" color="primary" @click="addItem">
                                                    <v-icon color="blue">mdi-plus</v-icon>
                                                  </v-btn>
                                                  <v-btn  @click.stop @mousedown.stop  v-if="(i != items.length - 1) || (items.length > 1)" icon variant="tonal" size="small" color="primary" class="pa-1" @click="removeItem(index)">
                                                    <v-icon color="red">mdi-close</v-icon>
                                                  </v-btn>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </v-expansion-panel-title>

                                      <!-- ================= ROW BODY ================= -->
                                      <v-expansion-panel-text style="padding:5px 20px;">
                                        <!-- BREAKDOWN TABLE -->
                                        <table style="width:100%; margin-top:10px; font-size:13px; border-collapse:collapse;">
                                          <tbody>
                                            <tr
                                              v-for="(b, bi) in item.breakdowns"
                                              :key="bi"
                                            >
                                              <td style="width:20%; padding: 0px 5px;">
                                                <v-autocomplete
                                                  class="mt-2"
                                                  variant="outlined"
                                                  density="compact"
                                                  label="Size*"
                                                  bg-color="grey-lighten-4"
                                                  v-model="b.size_id"
                                                  :items="getProductionSizeList"
                                                  :item-title="(item) =>`${item?.name ?? 'Select'} ${item?.code ?? ''}`"
                                                  item-value="id"
                                                  autocomplete="off"
                                                  hide-details
                                                  clearable
                                                  @update:model-value="onItemBreakdownSizeChange(i, bi)"
                                                ></v-autocomplete>
                                              </td>

                                              <td style="width:20%; padding: 0px 5px;">
                                                <v-autocomplete
                                                    class="mt-2"
                                                    variant="outlined"
                                                    density="compact"
                                                    label="Color*"
                                                    bg-color="grey-lighten-4"
                                                    v-model="b.color_id"
                                                    :items="getProductionColorList"
                                                    :item-title="(item) =>`${item?.name ?? 'Select'} ${item?.code ?? ''}`"
                                                    item-value="id"
                                                    autocomplete="off"
                                                    hide-details
                                                    clearable
                                                    @update:model-value="onItemBreakdownColorChange(i, bi)"
                                                  ></v-autocomplete>
                                              </td>

                                              <td style="padding: 0px 5px;">
                                                <v-text-field
                                                  v-model.number="b.quantity"
                                                  label="Quantity"
                                                  type="number"
                                                  min="0"
                                                  step="0.01"
                                                  variant="outlined"
                                                  density="compact"
                                                  class="text-right mt-2"
                                                  hide-details
                                                  @update:model-value="onItemBreakdownCalculationChange(i, bi)"
                                                  hide-spin-buttons
                                                />
                                              </td>

                                              <td style="padding: 0px 5px;">
                                                <v-text-field
                                                  v-model.number="b.unit_price"
                                                  type="number"
                                                  min="0"
                                                  step="0.01"
                                                  variant="outlined"
                                                  density="compact"
                                                  label="Unit price*"
                                                  class="text-right mt-2"
                                                  @update:model-value="onItemBreakdownCalculationChange(i, bi)"
                                                  hide-details
                                                  hide-spin-buttons
                                                />
                                              </td>

                                              <td style="padding: 0px 5px;">
                                                <v-text-field
                                                  v-model.number="b.total_price"
                                                  type="number"
                                                  min="0"
                                                  step="0.01"
                                                  variant="outlined"
                                                  density="compact"
                                                  label="Total price*"
                                                  class="text-right mt-2"
                                                  hide-details
                                                  hide-spin-buttons
                                                  readonly=""
                                                />
                                              </td>

                                              <td style="padding: 0px 5px;">
                                                <v-text-field
                                                  v-model.number="b.consumption"
                                                  type="number"
                                                  min="0"
                                                  step="0.01"
                                                  variant="outlined"
                                                  density="compact"
                                                  label="Consumption*"
                                                  class="text-right mt-2"
                                                  hide-details
                                                  hide-spin-buttons
                                                />
                                              </td>

                                              <td style="width: 90px; padding: 0px 5px;">
                                                
                                                <v-btn v-if="(bi != (item.breakdowns).length - 1) || ((item.breakdowns).length > 1)" icon variant="tonal" size="small" color="primary" class="pa-1" @click="removeBreakdown(i, bi)">
                                                  <v-icon color="red">mdi-close</v-icon>
                                                </v-btn>
                                                <v-btn v-if="bi == (item.breakdowns).length - 1" variant="tonal" icon size="small" color="primary" @click="addBreakdown(i)">
                                                  <v-icon color="blue">mdi-plus</v-icon>
                                                </v-btn>

                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>

                                      </v-expansion-panel-text>
                                    </v-expansion-panel>

                                  </v-expansion-panels>

                                </v-col>
                              </v-row> 


                            
                          </v-card-text>
                        </v-card>
                      </v-expansion-panel-text>

                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-col>
              </v-row>

              <v-divider class=""></v-divider>
              <!-- ACTION BUTTONS -->
              <v-card-actions class="justify-end">
                <v-btn color="white" class="bg-grey-darken-1 me-2" @click="submitForm(0)">Draft</v-btn>
                <v-btn color="primary" variant="flat" type="button" @click="submitForm(1)" class="ms-2">
                  {{ isEntryMode ? 'Save' : 'Update' }}
                </v-btn>
              </v-card-actions>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
  </v-app>
</template>

<script>
import { ref, onMounted } from "vue";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { useStore } from "vuex";
import { toast } from "vue3-toastify";
import { useRoute, useRouter } from "vue-router";

export default {
    created() {
        this.loading = true;
        this.$store.dispatch('getProductionStyleList').then((response) => {
            this.loading = false;
        });

        this.loading = true;
        this.$store.dispatch('getCustomerMapList').then((response) => {
            this.loading = false;
        });

        this.loading = true;
        this.$store.dispatch('getCurrencyList').then((response) => {
            this.loading = false;
        });

        this.loading = true;
        this.$store.dispatch('getProductionSizeList').then((response) => {
            this.loading = false;
        });

        this.loading = true;
        this.$store.dispatch('getProductionColorList').then((response) => {
            this.loading = false;
        });
      
    },
    
    computed: {
        getProductionStyleList() {
            return this.$store.getters.getProductionStyleList;
        },

        getCustomerMapList() {
            return this.$store.getters.getCustomerMapList;
        },

        getProductionSizeList(){
          return this.$store.getters.getProductionSizeList;
        },

        getProductionColorList(){
          return this.$store.getters.getProductionColorList;
        },

        getCurrencyList() {
            return this.$store.getters.getCurrencyList;
        },

        getOrderType(){
            return [
                { label: "Bulk", value: "Bulk" },
                { label: "Sample", value: "Sample" },
                { label: "Repeat", value: "Repeat" },
                { label: "Development", value: "Development" },
            ];
        },

        getSeason(){
            return [
                { label: "Summer", value: "Summer" },
                { label: "Winter", value: "Winter" },
                { label: "Spring", value: "Spring" },
                { label: "Fall", value: "Fall" },
            ];
        },

        getShipmentMode(){
            return [
                { label: "Sea", value: "Sea" },
                { label: "Air", value: "Air" },
                { label: "Courier", value: "Courier" },
            ];
        },

        getDeliveryTerm(){
            return [
                { label: "FOB", value: "FOB" },
                { label: "CFR", value: "CFR" },
                { label: "CIF", value: "CIF" },
                { label: "DDP", value: "DDP" },
            ];
        },

        getOrderPriority(){
            return [
                { label: "High", value: "High" },
                { label: "Medium", value: "Medium" },
                { label: "Low", value: "Low" },
            ];
        }

        // getHrmEmployeeList() {
        //     return this.$store.getters.getHrmEmployeeList;
        // },

    },
    setup() {
      const store = useStore();
      const route = useRoute();
      const router = useRouter();

      const panel = ref([0]);
      const panel2 = ref([0]);
      const panel3 = ref([0]);
      const isEntryMode = ref(true);

      const items = ref([
        {
          style_id: null,
          style_id: '',
          order_quantity: 1,
          // unit_price: 0,
          total_value:0,
          breakdowns: [
            {
              color_id: null,
              size_id: null,
              quantity: 1,
              unit_price: 0,
              total_price: 0,
              consumption: 0
            }
          ]
        }
      ]);


      // LOAD DROPDOWN DATA
      // store.dispatch("getProductionStyleList");
      // store.dispatch("getCustomerMapList");

      // FORM SETUP
      const { handleSubmit, resetForm, setValues, setFieldValue, errors } = useForm({
        initialValues: {
          id: null,
          buyer_id:null,
          order_date:null,
          order_receive_date:null,
          delivery_date:null,
          order_type:null,
          smv:null,
          efficiency:null,
          brand:null,
          season:null,
          shipment_date:null,
          shipment_mode:null,
          delivery_terms:null,
          currency_id:null,
          payment_terms:null,
          order_priority:null,
          sales_person:null,
          items: [{
            style_id: null,
            style_id: '',
            order_quantity: 1,
            // unit_price: 0,
            total_value:0,
            breakdowns: [
              {
                color_id: null,
                size_id: null,
                quantity: 1,
                unit_price: 0,
                total_price:0,
                consumption: 0
              }
            ]
          }],
        },

        validationSchema: yup.object({
          buyer_id: yup.number().required("Buyer is required"),
          order_date: yup.date().required("Order date is required"),
          order_receive_date: yup.date().nullable(),
          delivery_date: yup.date().required("Delivery date is required"),
          order_type: yup.string().oneOf(["Bulk","Sample","Repeat","Development"],"Invalid order type").required("Order type is required"),
          smv: yup.number().min(0,"SMV must be >= 0").nullable(),
          efficiency: yup.number().min(0,"Efficiency must be >= 0").nullable(),
          brand: yup.string().max(255,"Brand max 255 chars").nullable(),
          season: yup.string().oneOf(["Summer","Winter","Spring","Fall"],"Invalid season").required("Season is required"),
          shipment_date: yup.date().nullable(),
          shipment_mode: yup.string().oneOf(["Sea","Air","Courier"],"Invalid shipment mode").nullable(),
          delivery_terms: yup.string().oneOf(["FOB","CFR","CIF","DDP"],"Invalid delivery terms").nullable(),
          currency_id: yup.number().required("Currency is required"),
          payment_terms: yup.string().max(255,"Payment terms max 255 chars").nullable(),
          order_priority: yup.string().oneOf(["High","Medium","Low"],"Invalid priority").nullable(),
          sales_person: yup.string().max(255,"Sales person max 255 chars").nullable(),
          // items: yup.array().of(
          //   yup.object({
          //     style_id: yup
          //       .string()
          //       .required("Style is required"),
          //     order_quantity: yup
          //       .number()
          //       .min(1, "Order Quantity must be at least 1")
          //       .required("Order Quantity is required"),
          //     unit_price: yup
          //       .number()
          //       .min(1, "Unit Price must be at least 1")
          //       .required("Unit Price is required"),
          //     total_value: yup
          //       .number()
          //       .min(0, "Total Value must be >= 0")
          //       .required("Total Value is required"),
          //     breakdowns: yup.array().of(
          //       yup.object({
          //         size_id: yup
          //           .string()
          //           .required("Size is required"),
          //         color_id: yup
          //           .string()
          //           .required("Color is required"),
          //         quantity: yup
          //           .number()
          //           .min(1, "Quantity must be at least 1")
          //           .required("Quantity is required"),
          //         unit_price: yup
          //           .number()
          //           .min(1, "Unit Price must be at least 1")
          //           .required("Unit Price is required"),
          //         consumption: yup
          //           .number()
          //           .min(0, "Consumption must be >= 0")
          //           .required("Consumption is required"),
          //       })
          //     ).min(1, "At least one breakdown is required"),
          //   })
          // ).min(1, "At least one item is required"),
        }),
      });

      const buyer_id = useField("buyer_id");
      const order_date = useField("order_date");
      const order_receive_date = useField("order_receive_date");
      const delivery_date = useField("delivery_date");
      const order_type = useField("order_type");
      const smv = useField("smv");
      const efficiency = useField("efficiency");
      const brand = useField("brand");
      const season = useField("season");
      const shipment_date = useField("shipment_date");
      const shipment_mode = useField("shipment_mode");
      const delivery_terms = useField("delivery_terms");
      const currency_id = useField("currency_id");
      const payment_terms = useField("payment_terms");
      const order_priority = useField("order_priority");
      const sales_person = useField("sales_person");

      // EDIT MODE
      onMounted(() => {
        if (route.params.id) {
          const id = route.params.id;
          isEntryMode.value = false;

          setValues({ id: id });

          store.dispatch("getBuyerOrderById", { id })
          .then((res) => {
            const data = res.data.data;

            setValues({
              id: data.id || null, // id thakle use korbe, na thakle null
              buyer_id: data.buyer_id,
              order_date: data.order_date,
              order_receive_date: data.order_receive_date,
              delivery_date: data.delivery_date,
              order_type: data.order_type,
              smv: data.smv,
              efficiency: data.efficiency,
              brand: data.brand,
              season: data.season,
              shipment_date: data.shipment_date,
              shipment_mode: data.shipment_mode,
              delivery_terms: data.delivery_terms,
              currency_id: data.currency_id,
              payment_terms: data.payment_terms,
              order_priority: data.order_priority,
              sales_person: data.sales_person,
              status: data.status,
            });

            items.value = data.items.map(i => ({
              style_id: i.style_id,
              order_quantity: i.order_quantity,
              // unit_price: i.unit_price,
              total_value: i.total_value,
              breakdowns: i.breakdowns.map(b => ({
                size_id: b.size_id,
                color_id: b.color_id,
                quantity: b.quantity,
                unit_price: b.unit_price,
                total_price: b.quantity * b.unit_price,
                consumption: b.consumption,
              }))
            }));

          })
          .catch((error) => {
            console.error(error); // ✅ Dekhar jonno
            toast.error("Failed to load Order");
          });

        }
      });

      const submitForm = (status) => {
        setFieldValue('status', status);
        submit();                       
      };

      // SUBMIT
      const submit = handleSubmit((values) => {
        const payload = {
          id: null,
          buyer_id: values.buyer_id,
          order_date: values.order_date,
          order_receive_date: values.order_receive_date,
          delivery_date: values.delivery_date,
          order_type: values.order_type,
          smv: values.smv,
          efficiency: values.efficiency,
          brand: values.brand,
          season: values.season,
          shipment_date: values.shipment_date,
          shipment_mode: values.shipment_mode,
          delivery_terms: values.delivery_terms,
          currency_id: values.currency_id,
          payment_terms: values.payment_terms,
          order_priority: values.order_priority,
          sales_person: values.sales_person,
          status: values.status,
          items: items.value.map(i => ({
              style_id: i.style_id,
              order_quantity: i.order_quantity,
              // unit_price: i.unit_price,
              total_value: i.total_value,
              breakdowns: i.breakdowns.map(b => ({
                  size_id: b.size_id,
                  color_id: b.color_id,
                  quantity: b.quantity,
                  unit_price: b.unit_price,
                  total_price: b.unit_price * b.quantity,
                  consumption: b.consumption,
              }))
          }))
        };

        if (values.id) {
          store
            .dispatch("updateBuyerOrder", { id: values.id, data: payload })
            .then(() => {
                toast.success("Buyer Order Updated Successfully!");
                router.push({ name: "buyer-order-records" });
            })
            .catch((err) => toast.error(err.response?.data?.message || "Failed to update buyer order"));
        } else {
          store
            .dispatch("saveBuyerOrder", payload)
            .then(() => {
              toast.success("Buyer Order Created Successfully!");
              router.push({ name: "buyer-order-records" });
            })
            .catch((err) => toast.error(err.response?.data?.message || "Failed to create buyer order"));
        }
      });

      return {
        panel,
        panel2,
        panel3,
        isEntryMode,
        submit,
        resetForm,
        buyer_id,
        order_date, 
        order_receive_date, 
        delivery_date, 
        order_type,
        smv, 
        efficiency, 
        brand, 
        season, 
        shipment_date, 
        shipment_mode, 
        delivery_terms, 
        currency_id, 
        payment_terms, 
        order_priority, 
        sales_person,
        submitForm,
        items,
      //   styleList: store.getters.getProductionStyleList,
      };
    },
    methods: {
      addItem() {
        this.items.push({
          style_id: null,
          style_id: '',
          order_quantity: 1,
          // unit_price: 0,
          total_value: 0,
          breakdowns: [
            {
              color_id: null,
              size_id: null,
              quantity: 1,
              unit_price: 0,
              total_price: 0,
              consumption: 0,
            }
          ]
        });
      },
      addBreakdown(i) {
        this.items[i].breakdowns.push({
          color_id: null,
          size_id: null,
          quantity: 1,
          unit_price: 0,
          total_price:0,
          consumption: 0,
        });
      },
      removeItem(itemIndex) {
        this.items.splice(itemIndex, 1);
      },
      removeBreakdown(itemIndex, breakdownIndex) {
        this.items[itemIndex].breakdowns.splice(breakdownIndex, 1);
      },
      // onItemQuantityChange(i){
      //   this.items[i].total_value = (this.items[i].order_quantity * this.items[i].unit_price);
      // },
      // onItemUnitPriceChange(i){
      //   this.items[i].total_value = (this.items[i].order_quantity * this.items[i].unit_price);
      // },

      onItemStyleChange(i) {
        const currentStyleId = this.items[i].style_id;
        const duplicate = this.items.some((item, index) => index !== i && item.style_id === currentStyleId);
        if (duplicate) {
          this.items[i].style_id = null;
          toast.error('This style is already selected in another item!');
        }
      },

      onItemBreakdownSizeChange(itemIndex, breakdownIndex) {
        let duplicateFound = this.onItemBreakdownChange(itemIndex, breakdownIndex);
        if(duplicateFound){
          this.items[itemIndex].breakdowns[breakdownIndex].size_id = null;
          toast.error('This Size and Color combination is already selected!');
        }
      },

      onItemBreakdownColorChange(itemIndex, breakdownIndex) {
        let duplicateFound = this.onItemBreakdownChange(itemIndex, breakdownIndex);
        if(duplicateFound){
          this.items[itemIndex].breakdowns[breakdownIndex].color_id = null;
          toast.error('This Size and Color combination is already selected!');
        }
      },

      onItemBreakdownCalculationChange(itemIndex, breakdownId) {
          let totalQty = 0;
          let totalValue = 0;
          this.items[itemIndex].breakdowns.forEach(breakdown => {
            totalQty += Number(breakdown.quantity || 0);
            breakdown.total_price = breakdown.quantity * breakdown.unit_price;
            totalValue += Number(breakdown.total_price || 0);
          });
          this.items[itemIndex].order_quantity = totalQty;
          this.items[itemIndex].total_value = totalValue;
      },

      onItemBreakdownChange(itemIndex, breakdownIndex) {
        const currentBreakdown = this.items[itemIndex].breakdowns[breakdownIndex];
        const { size_id, color_id } = currentBreakdown;

        if (!size_id || !color_id) return;
        let duplicateFound = false;
        this.items[itemIndex].breakdowns.forEach((b, bi) => {
          if (bi !== breakdownIndex) {
            if (b.size_id === size_id && b.color_id === color_id) {
              duplicateFound = true;
            }
          }
        });
        return duplicateFound;
      }
    }
};
</script>

<style scoped>
  .border-thick {
    border-width: 1px !important;
    color:#000;
  }
</style>
